import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import * as API from 'api';
import { ApiResponse, IApiQueryOptions } from 'api/ApiClient';
import { IAchTransaction, IAction, IApiList } from 'types';
import * as Actions from './actions';
import { Ach } from './types';

export function* getAchTransactions({ payload }: IAction<Ach, { siteId: string; options?: IApiQueryOptions }>): any {
  try {
    const { siteId, options } = payload;
    const response: ApiResponse<IApiList<IAchTransaction>> = yield call(API.Sites.listAchTransactions, siteId, options);

    yield put(Actions.getSiteAchTransactionsSuccess(response.body));
  } catch (error) {
    yield put(Actions.getSiteAchTransactionsError(error));
  }
}

export function* watchGetAchTransactions() {
  yield takeEvery(Ach.GET_TRANSACTIONS_REQUEST, getAchTransactions);
}

function* achSaga() {
  yield all([fork(watchGetAchTransactions)]);
}

export { achSaga };
